var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-wrap"},[_c('div',{staticClass:"login-text"},[_c('div',{staticClass:"text"},[_c('Login')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }